module.exports = new __parcel__URL__("dependency-graph.125d36c6.svg").toString();